module.exports = require('./components/Modal');




//////////////////
// WEBPACK FOOTER
// ./~/react-modal/lib/index.js
// module id = 511
// module chunks = 4 6 7 8 9 12 14 16 22 56 57